import { render, staticRenderFns } from "./checkMRI.vue?vue&type=template&id=2ed2ea36&scoped=true"
import script from "./checkMRI.vue?vue&type=script&lang=js"
export * from "./checkMRI.vue?vue&type=script&lang=js"
import style0 from "./checkMRI.vue?vue&type=style&index=0&id=2ed2ea36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2ea36",
  null
  
)

export default component.exports